import { FirstAuthCompletedInitGetRequestModel } from "@/features/user/services/first-auth-completed-model";
import { FirstAuthCompletedApi } from "@/features/user/services/first-auth-completed-api";

// 利用者ID初回認証完了ページ表示前処理
export class FirstAuthCompletedService {
  private firstAuthCompletedApi = new FirstAuthCompletedApi();
  /**
   * 利用者ID初回認証完了ページ表示前処理API実行
   */
  public async firstAuthCompletedInit(param: FirstAuthCompletedInitGetRequestModel) {
    return await this.firstAuthCompletedApi.firstAuthCompletedInit(param);
  }
}
